import { createAsyncThunk } from '@reduxjs/toolkit';
import { callGetAccount, callLogin, callSwitchTenant } from 'helpers/api_helper';
import { Dispatch } from 'redux';
import { loginError } from './reducer';

export interface IUser {
  username: string;
  password: string;
  tenantId: number;
  rememberMe?: boolean;
}

export const login = createAsyncThunk('auth/callLogin', async (param: IUser, { rejectWithValue }) => {
  try {
    const response = await callLogin(param);
    return response;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getAccount = createAsyncThunk('auth/callGetAccount', async (_, { rejectWithValue }) => {
  try {
    const response = await callGetAccount();
    return response;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const switchTenant = createAsyncThunk('auth/callSwitchTenant', async (param: any, { rejectWithValue }) => {
  try {
    const response = await callSwitchTenant(param);
    return response;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const logoutUser = () => async (dispatch: Dispatch) => {
  try {
    localStorage.removeItem('token');
  } catch (error) {
    dispatch(loginError(error));
  }
};
